import { formatDate } from "../lib/format";
import type { WorkItem, WorkItemLink } from "../types/domain";

const linkLabels: Record<WorkItemLink["linkType"], string> = {
  repository: "Repositorio",
  branch: "Rama",
  commit: "Commit",
  pull_request: "Pull request",
  ci: "CI",
  document: "Documento",
  evidence: "Evidencia",
  issue: "Incidencia",
  deployment: "Deploy",
  other: "Otro",
};

export function EvidenceView({ links, items }: { links: WorkItemLink[]; items: WorkItem[] }) {
  const itemById = new Map(items.map((item) => [item.id, item]));
  return (
    <div className="view-stack">
      <section className="section-toolbar">
        <div>
          <span className="eyebrow">Referencias, no copias</span>
          <h2>Biblioteca de evidencia</h2>
          <p>
            El dashboard enlaza la fuente técnica. No transforma hashes, manifests ni trazas en
            datos propios.
          </p>
        </div>
      </section>
      <section className="evidence-grid">
        {links.map((link) => (
          <a
            className="evidence-card"
            href={link.url}
            target="_blank"
            rel="noreferrer"
            key={link.id}
          >
            <div>
              <span className={`link-type link-type--${link.linkType}`}>
                {linkLabels[link.linkType]}
              </span>
              <span className="muted">{formatDate(link.createdAt)}</span>
            </div>
            <h3>{link.label}</h3>
            <p>
              {link.workItemId
                ? (itemById.get(link.workItemId)?.title ?? "Elemento vinculado")
                : "Proyecto"}
            </p>
            <footer>
              <span>{link.externalId ? `ID ${link.externalId}` : "Fuente externa"}</span>
              <span>Abrir ↗</span>
            </footer>
          </a>
        ))}
      </section>
    </div>
  );
}
